import { makeApiRequest } from 'actions/api';
import { GET_USER_V3 } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

export const getUser = () =>
  makeApiRequest({
    requestType: GET_USER_V3,
    method: RequestService.v3.getUser,
  });
